import React from 'react'


export const RenderDoneDialogUnidentify = (doneMessage, renderCloseMessage, childControls, stateCode)=>{

    return(
        <div className="user-message-wrapper fadeInDown">
        <div className="login-form-content">
                {stateCode == "37" && <div className="pcrb-logo"></div>}
                {stateCode == "07" && <div className="dcrb-logo"></div>}
                {stateCode == "" && <div className="dual-logo"></div>}
          <form>
            <h4 className="code-login-welcome">
              {doneMessage.message}   
              { doneMessage.subMessage &&
               <p>
                   { doneMessage.subMessage }                  
                </p>
            }               
            </h4>
                {renderCloseMessage && doneMessage.message && doneMessage.message.toLowerCase().includes("saved") &&                           
                <div>
                    Close the browser tab, click <a href="http://www.pcrb.com">here</a> to visit the PCRB/DCRB home page 
                </div>                
            }            
          </form>                      
                {doneMessage.message && doneMessage.message.toLowerCase().includes("saved") && childControls}
        </div>
      </div>
    );    

}

